module.exports = __webpack_public_path__ + "static/1-c031419f93a306dbded908489c563e2d.jpg";